import { Sport } from '@sorare/core/src/__generated__/globalTypes';

export const PROJECTION_WITH_DIFFERENCE_BY_SPORT: Record<Sport, boolean> = {
  [Sport.NBA]: true,
  [Sport.FOOTBALL]: false,
  [Sport.BASEBALL]: false,
};
